// hubl form js
$(document).ready(function() {
  var firstNameInput;
  var lastNameInput;
  var emailInput;
  var phoneNumberInput;
  var companyWebsiteInput;
  var productQuantities;
  var selectedProducts = [];
  var urgencyTimeline;
  var selectedProductsString='';
  var newsletterSubscription;
  var industryType;
        $("#hubspot-form").submit(function(event) {
            event.preventDefault();

            firstNameInput = $("#hubspot-form-FirstName");
            lastNameInput = $("#hubspot-form-LastName");
            emailInput = $("#hubspot-form-email");
            phoneNumberInput = $("#hubspot-form-PhoneNumber");
            companyWebsiteInput = $("#hubspot-form-CompanyName");
            productQuantities = $("input[name='contact[CustomQuantity]']:checked");
            urgencyTimeline = $("input[name='contact[Urgency/timeline]']:checked").val();
            industryType = $("#hubspot-form-industry_type");
            
          
            selectedProducts = [];
            $("input[name='contact[ProductTypes]']:checked").each(function() {
                selectedProducts.push($(this).val());
            });
            selectedProductsString = selectedProducts.join(';');

            var newsletterSubscription = $("#hubspot-form-inp-subscription").prop('checked');

            var isValid = true;


            if (firstNameInput.val().trim() === "") {
                isValid = false;
                firstNameInput.next().show();
            } else {
                firstNameInput.next().hide();
            }

            if (lastNameInput.val().trim() === "") {
                isValid = false;
                lastNameInput.next().show();
            } else {
                lastNameInput.next().hide();
            }

            var email = emailInput.val().trim();

            if (email === "" || // Check if the email is empty
                !isValidEmail(email) || // Check if the email is not valid
                isTestEmail(email) // Check if the email is a test email
            ) {
                isValid = false;
                if (email === "") {
                    emailInput.next().text("Please enter an email address.").show(); // Show error message for empty email
                } else if (!isValidEmail(email)) {
                    emailInput.next().text("Please enter a valid email address.").show(); // Show error message for invalid email format
                } else if (isTestEmail(email)) {
                    emailInput.next().text("Emails are not allowed.").show(); // Show error message for test email
                }
            } else {
                emailInput.next().hide(); // Hide error message
            }
            
            // Function to check if the email is valid
            function isValidEmail(email) {
                // Regular expression to check email format
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(email);
            }
            
            // Function to check if the email is a test email
            function isTestEmail(email) {
                // Regular expression to match test email patterns
                var testEmailRegex = /(?:\b|_)(?:test|example|sample|demo)(?:\b|_)?@/i;
                return testEmailRegex.test(email);
            }


            if (phoneNumberInput.val().trim() === "") {
                isValid = false;
                phoneNumberInput.next().show();
            } else {
                phoneNumberInput.next().hide();
            }

            if (companyWebsiteInput.val().trim() === "") {
                isValid = false;
                companyWebsiteInput.next().show();
            } else {
                companyWebsiteInput.next().hide();
            }

            if (productQuantities.length === 0) {
                isValid = false;
                $(".error-quantity").show();
            } else {
                $(".error-quantity").hide();
            }

            if (isValid) {
                //$(this).unbind('submit').submit();
                console.log('form valid...');
                submit_form_data();
            }
        });

    function submit_form_data() {
        console.log('call submit_form_data..');
        if ($('.cmd-hubl-form .invalid').length > 0 || $('.cmd-hubl-form .error').length) {
            console.log('.cmd-hubl-form has invalid or error class');
        }
        else
        {
          
            console.log('.cmd-hubl-form does not have invalid or error class');
            var productQnt=productQuantities.val();
            if(productQnt=='< 5,000'){
              console.log('step 2');
              $('#hubspot-form fieldset').addClass('hide');
              $('#hubspot-form fieldset.steps-2-content').removeClass('hide');
              
            }
            else
            {
                console.log('submit form..');
                $('.cmd-hubl-form  form .actions input[type="submit"]').click();
                if($('.hs_error_rollup').length){
                  $("#responce").html($(".hs_error_rollup").html());
                }
            }
 
        }
    }

    $('.steps-2-content input.previous').click(function() {
          $('#hubspot-form fieldset').addClass('hide');
          $('#hubspot-form fieldset.steps-1-content').removeClass('hide');
    });

    $('.steps-2-content input.next').click(function() {
          $('.cmd-hubl-form  form .actions input[type="submit"]').click();
    });

    //hubspot form submit event
    window.addEventListener('message', event => {
       if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted' && event.data.id === '96922576-bf81-428b-acc2-8f9a4f43804c') {
           
         $('#hubspot-form fieldset').addClass('hide');
         $('#hubspot-form fieldset.success-msg-wrap').removeClass('hide');
          
           console.log("Form Submitted!");
       }
    });
  
});
  

   

    // Function to synchronize input fields, radio buttons, or checkboxes
   function synchronizeFields(sourceName, targetName, fieldType) {
    // Event listener for changes in the source fields
        $('#hubspot-form [name="' + sourceName + '"]').on('change keyup', function() {
            // Get the selected value
            var selectedValue = $(this).val();
            // Check if the field is a checkbox
            if (fieldType === 'checkbox') {
                // Check if the source checkbox is checked
                var isChecked = $(this).is(':checked');
                // Iterate over each target checkbox and synchronize it
                $('.cmd-hubl-form [name="' + targetName + '"]').each(function() {
                    if ($(this).val() === selectedValue) {
                        $(this).prop('checked', isChecked);
                    }
                });
            } else {
                // For radio buttons and input fields, set the value of the corresponding field in the target set
                $('.cmd-hubl-form [name="' + targetName + '"]').val(selectedValue).change();
            }
        });
    }

    // Call the function to synchronize input fields, radio buttons, or checkboxes between the two sets
    
    synchronizeFields('contact[ProductTypes]', 'producttypes', 'checkbox');
    synchronizeFields('contact[other product]', 'other_product', 'input');

    
    synchronizeFields('contact[CustomQuantity]', 'custom_quantity_new', 'radio');
    synchronizeFields('contact[Urgency/timeline]', 'urgency_timeline', 'radio');

    synchronizeFields('contact[FirstName]', 'firstname', 'input');
    synchronizeFields('contact[LastName]', 'lastname', 'input');
    synchronizeFields('contact[email]', 'email', 'input');
    synchronizeFields('contact[PhoneNumber]', 'phone', 'input');
    synchronizeFields('contact[CompanyWebsite]', 'companywebsite', 'input');

    synchronizeFields('contact[subscribe_to_our_newsletter]', 'subscribe_to_our_newsletter', 'checkbox');

    synchronizeFields('contact[industry_type]', 'industry_type', 'input');




//show popup getquote on getquote button click code
$(document).ready(function() {
  $("#myPopup").css("display", "none"); // Hide the popup initially

  $("#customPackagingTriggerbutton").click(function() {
    $("#myPopup").css("display", "block");
  });

  $("#customPackagingTriggerquote").click(function() {
    $("#myPopup").css("display", "block");
  });

    $("#customPackagingTriggertext").click(function() {
        $("#myPopup").css("display", "block");
        if ($('#myPopup').hasClass('show')) {
            $('#myPopup').addClass('show');
          }else{
            $('#myPopup').addClass('show');
          }
  });
  
 
});


// Function to synchronize email input value between contact and customer forms
  function syncEmail() {
    var contactEmail = $('#QQForm-email').val();
    $('#Susbscription-email').val(contactEmail);

    var first_name = $('#QQForm-FirstName').val();
    var last_name = $('#QQForm-LastName').val();
    var phone_number = $('#QQForm-PhoneNumber').val();
    var company_name = $('#QQForm-CompanyName').val();

    $('#Susbscription-FirstName').val(first_name);
    $('#Susbscription-LastName').val(last_name);
    $('#Susbscription-PhoneNumber').val(phone_number);
    $('#Susbscription-CompanyName').val(company_name);
    
  }

$(document).ready(function() {
  // Attach event listeners to the input fields in the first form
  $('#QQForm-email, #QQForm-FirstName, #QQForm-LastName, #QQForm-PhoneNumber, #QQForm-CompanyName').on('click change', syncEmail);
});

  // Function to trigger the click event of the customer form submit button
  function triggerCustomerFormSubmit() {
  <!--triger code start here-->

$("#btn-qq-submit").click(function(e) {
  e.preventDefault(); // Prevent default form submission behavior
  // Submit customer form
  $('#Susbscription').submit();
  // Delayed submission of the 'Get Quote' form
  setTimeout(function() {
    $('#btn-qq-submit').submit();
  }, 2000); // 2-second delay
});

  <!-- triger code end here--> 
  }

$('.subscription_submit').prop('disabled', true);

// Event listener for checkbox change
  $('#QQForm-inp-subscription').change(function() {
    if ($(this).is(':checked')) {
      syncEmail(); // Synchronize email input value
      triggerCustomerFormSubmit(); // Trigger customer form submit
       $('.subscription_submit').prop('disabled', false); // Enable the button
    }else{
       $('.subscription_submit').prop('disabled', true); // Disable the button
    }
  });

  //add class above 5000 or below 5000 code

$(document).ready(function() {
  // Function to check if any input field is empty
  function checkEmptyFields() {
    var firstName = $('#QQForm-FirstName').val().trim();
    var lastName = $('#QQForm-LastName').val().trim();
    var email = $('#QQForm-email').val().trim();
    var phoneNumber = $('#QQForm-PhoneNumber').val().trim();
    var companyName = $('#QQForm-CompanyName').val().trim();

    

    if (firstName === '' || lastName === '' || email === '' || phoneNumber === '' || companyName === '') {
      console.log('One or more fields are empty');
      $("#btn-qq-submit-lessthanminimum").removeClass("abovefive belowfive"); // Remove both "abovefive" and "belowfive" classes if any field is empty
      $("#btn-qq-submit").removeClass("abovefive belowfive"); // Remove both "abovefive" and "belowfive" classes if any field is empty
    } else {
      console.log('All fields have values');
      var inputValue = ($('input[name="contact[CustomQuantity]"]:checked').val());
      console.log('123',inputValue);

        if (inputValue != '< 5,000' ) {
          console.log("Value is above 5000");
          $("#btn-qq-submit-lessthanminimum").removeClass("belowfive").addClass("abovefive"); // Add "abovefive" class and remove "belowfive" class
          $("#btn-qq-submit").removeClass("belowfive").addClass("abovefive"); // Add "abovefive" class and remove "belowfive" class
        } else {
          console.log("Value is below 5000");
          $("#btn-qq-submit-lessthanminimum").removeClass("abovefive").addClass("belowfive"); // Add "belowfive" class and remove "abovefive" class
           $("#btn-qq-submit").removeClass("abovefive").addClass("belowfive"); // Add "belowfive" class and remove "abovefive" class
        }
     
    }
  }

  $('#QQForm-quantity-in-quick-quote-input').on('input', function() {
    checkEmptyFields(); // Call the checkEmptyFields() function to check if any field is empty and update the class
  });

  // Event handler for input fields
  $('#QQForm-FirstName, #QQForm-LastName, #QQForm-email, #QQForm-PhoneNumber, #QQForm-CompanyName').on('input', function() {
    checkEmptyFields(); // Call the checkEmptyFields() function to check if any field is empty and update the class
  });
});




 //hiding button

  var lessThanMinimumButton = document.getElementById("btn-qq-submit-lessthanminimum");
  if (lessThanMinimumButton) {
    lessThanMinimumButton.style.display = "none";
  }

  var current_fs, next_fs, previous_fs; //fieldsets

  function getQuotePopup(trigger) {
    var source = trigger && trigger.nodeType === 1 && typeof trigger.closest === "function" ? trigger : null;
    var popup = null;

    if (source) {
      var section = source.closest("section");
      if (section) {
        popup = section.querySelector("#myPopup, .quote-btn-content");
      }

      if (!popup) {
        popup = source.closest("#myPopup, .quote-btn-content");
      }

      if (!popup && source.classList && source.classList.contains("quote-btn")) {
        popup = document.querySelector(".quote-btn-content");
      }
    }

    return popup || document.getElementById("myPopup");
  }

  function showQuotePopup(eventOrTrigger) {
    var trigger = eventOrTrigger && eventOrTrigger.currentTarget
      ? eventOrTrigger.currentTarget
      : eventOrTrigger;
    var popup = getQuotePopup(trigger);
    if (!popup) return false;

    popup.style.display = "block";
    popup.classList.add("show");
    return true;
  }

  function hideQuotePopup(eventOrTrigger) {
    var trigger = eventOrTrigger && eventOrTrigger.currentTarget
      ? eventOrTrigger.currentTarget
      : eventOrTrigger;
    var popup = getQuotePopup(trigger);
    if (!popup) return false;

    popup.style.display = "none";
    popup.classList.remove("show");
    return true;
  }

  window.quoteform = function(trigger) {
    return showQuotePopup(trigger || (window.event && (window.event.currentTarget || window.event.target)));
  };

  hideQuotePopup();

  var quoteTriggerSelector = [
    "#customPackagingTrigger",
    "#customPackagingTriggerbutton",
    "#customPackagingTriggerquote",
    "#customPackagingTriggertext",
    "#customBtnQuote"
  ].join(", ");

  document.querySelectorAll(quoteTriggerSelector).forEach(function(trigger) {
    trigger.addEventListener("click", showQuotePopup);
  });

  $(document).click(function(e) {
    if (!$(e.target).closest("#myPopup, .quote-btn-content, " + quoteTriggerSelector).length) {
      hideQuotePopup();
    }
  });


  

  

       $(".next").click(function(){
      
      if($(this).hasClass('validity_check_button')){
        
        var fName = $('#QQForm-FirstName').val();
        var lName = $('#QQForm-LastName').val();
        var email = $('#QQForm-email').val()
        var phonenumber = $('#QQForm-PhoneNumber').val();
        var website = $('#QQForm-CompanyName').val();
        // var quantity = $('#QQForm-quantity-in-quick-quote-input').val();
        var quantity = $('input[name="contact[CustomQuantity]"]:checked').val();
        var confirm = $("input[name='contact[confirm/yes]']:checked").val()
        
        if(fName == ''){
          $('#QQForm-FirstName').siblings('.error').show();
        }else{
          $('#QQForm-FirstName').siblings('.error').hide();
        }
        
        if(lName == ''){
          $('#QQForm-LastName').siblings('.error').show();
        }else{
          $('#QQForm-LastName').siblings('.error').hide();
        }
        
        if(email == ''){
          $('#QQForm-email').siblings('.error').show();
        }else{
          $('#QQForm-email').siblings('.error').hide();
        }

        if(phonenumber == ''){
          $('#QQForm-PhoneNumber').siblings('.error').show();
        }else{
          $('#QQForm-PhoneNumber').siblings('.error').hide();
        }
        
        if(website == ''){
          $('#QQForm-CompanyName').siblings('.error').show();
        }else{
          $('#QQForm-CompanyName').siblings('.error').hide();
        }
        // if(quantity == undefined){
        //   $('.product-quantities').siblings('.error').show();
        // }else{
        //   $('.product-quantities').siblings('.error').hide();
        // }

             if (quantity == undefined) { // Check if no quantity is selected
               $('.custom-qtyerror').show();
                   console.log("error exist");
            } else {
                   console.log("no error exist");
             $('.custom-qtyerror').hide();    
             }
       
        
        if((fName != '') && (lName != '') && (email != '') && (phonenumber != '') && (website != '') && (quantity != undefined)) {
          current_fs = $(this).parent();
          next_fs = $(this).parent().next();

          if(quantity == '< 5,000'){
           
            //show the next fieldset
               next_fs.show();
               
                //hide the current fieldset with style
          current_fs.animate({opacity: 0}, {
            step: function(now) {
              // for making fielset appear animation
              opacity = 1 - now;

              current_fs.css({
                'display': 'none',
                'position': 'relative'
              });
              next_fs.css({'opacity': opacity});
            },
            duration: 500
          });
                  
         console.log(" values : "+$('#QQForm-FirstName').val());
         console.log(" values : "+$('#QQForm-LastName').val());
         console.log(" values : "+$('#QQForm-email').val());
         console.log(" values : "+$('#QQForm-PhoneNumber').val());
         console.log(" values : "+$('#QQForm-CompanyName').val());
         console.log(" values : "+$('input[name="contact[CustomQuantity]"]:checked').val());
         
                
               
            return true;    
          }else
            return true;
        }
        
      }else{
        
        current_fs = $(this).parent();
        next_fs = $(this).parent().next();

       //show the next fieldset
        next_fs.show();
        //hide the current fieldset with style
        current_fs.animate({opacity: 0}, {
          step: function(now) {
            // for making fielset appear animation
            opacity = 1 - now;

            current_fs.css({
              'display': 'none',
              'position': 'relative'
            });
            next_fs.css({'opacity': opacity});
          },
          duration: 500
        });
          return true;
      }
  });
  
  
  
  $(".previous").click(function(){
              window.location.href = "https://www.ecopackables.com/collections/stock-packaging";
              return true;
            })
 
                  

  
$(document).click(function(e) {
  /**** when click on window close the popup ******/
   var popup = document.getElementById("myPopup");
   var closepopup = document.getElementById("close-qq-popup");
   var $target = $(e.target);
   var popupContent = $(".custom-quick-quote-main-content");
   if ($target.is(popup || closepopup )) {
    hideQuotePopup(e.target);
    }
});



const quantityRadios = document.querySelectorAll('.customquantities');

quantityRadios.forEach(function(radio) {
  radio.addEventListener('change', function(e) {
    const selectedQuantity = e.target.value;
    console.log('jj',selectedQuantity);
    if (selectedQuantity == '< 5,000') {
      var lessThanMinimumButton = document.getElementById("btn-qq-submit-lessthanminimum");
      if (lessThanMinimumButton) {
        lessThanMinimumButton.style.display = "block";
      }
      var submitbtn = $('#btn-qq-submit');
      var submit_txt =$(".hidden-submittext").val();
     $('#btn-qq-submit').val(submit_txt) ;
      $( "#step-2nd" ).append(submitbtn);
      
    }
  });
});

  /*********** timeline validation ******************/

  
   document.querySelectorAll("#close-qq-popup, .close-popup").forEach(function(closeQuotePopup) {
     closeQuotePopup.addEventListener("click", hideQuotePopup);
  });
